module.exports = __webpack_public_path__ + "img/table-icon-gear.30d29f1e.png";